import {
  ApiProtectedSwitchOutOperation,
  ApiSwitchOutInstruction,
  ApiSwitchOutOperation
} from '@/api/rtk-api'
import { PresentationalTable } from '@/components/core-v2'
import { Currency, formatCurrencyFull } from '@/utilities/currency'

import { MetaInformation } from './event-information'

const getType = (isFull: boolean) => (isFull ? 'Full' : 'Partial')

export interface SwitchOutProps {
  currency: Currency
  operation: ApiSwitchOutOperation | ApiProtectedSwitchOutOperation
  value: number
}

export const SwitchOut = ({ currency, operation, value }: SwitchOutProps) => {
  const associatedInstruction = operation.associatedInstruction as ApiSwitchOutInstruction
  const requestedSwitchType = getType(associatedInstruction.isFullSwitch)
  const amount = associatedInstruction.isFullSwitch ? value : associatedInstruction.switchAmount

  const executedSwitchType = getType(operation.isFullSwitchOut)
  const executedAmount = operation.completedValue
  return (
    <>
      <MetaInformation>
        <span>
          Requested Switch Type: <strong>{requestedSwitchType}</strong>
        </span>
        <span>
          Requested Switch Amount: <strong>{formatCurrencyFull(amount, currency)}</strong>
        </span>
      </MetaInformation>
      <PresentationalTable
        headerRow={['Parameter', 'Outcome']}
        rowOptions={[
          { align: 'left', width: '75%' },
          { align: 'right', width: '25%' }
        ]}
        rows={[
          ['Executed Switch Type', executedSwitchType],
          ['Executed Switch Amount', formatCurrencyFull(executedAmount, currency)]
        ]}
      />
    </>
  )
}
